import React, {useState} from 'react';
import {Grid, Button, Typography} from '@material-ui/core';
import InputField from '../../../../FormikUtils/InputField';
import {FieldArray, useFormikContext} from 'formik'
import ClearIcon from '@material-ui/icons/Clear';
import {makeStyles} from "@material-ui/core/styles";
import Divider from '@material-ui/core/Divider';
import Thumb from "../../../../../../components/Thumb";
import PopOverCustom from "../../../../../PopOver";
import ButtonBase from '@material-ui/core/ButtonBase';
import CarPhotosDialog from "../../../../../adviser/Cotizacion/CarPhotosDialog";
import {gql} from "@apollo/client";
import SlantedField from "../../../../FormikUtils/SlantedField";
import {Dropzone, MIME_TYPES} from "@mantine/dropzone";
import {Group, Text} from "@mantine/core";
import { IconUpload, IconPhoto, IconX } from '@tabler/icons';

const useStyles = makeStyles(() => ({
    listRow: {
        alignItems: 'center',
    },
    buttonForm: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        backgroundColor: "#BB0D66",
        marginLeft: "5px",
        marginRight: "5px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    buttonForm2: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        backgroundColor: "#9A9A9A",
        marginLeft: "5px",
        marginRight: "5px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    disabled: {
        backgroundColor: "#f8f9fa",
        borderColor: "#f8f9fa",
        cursor: 'not-allowed',
        //
        '& *': {
            color: "#adb5bd",
        },
    }
}));

export default function VehiculoForm(props) {
    const classes = useStyles();
    const {
        formField: {
            motovehiculo: {
                patente,
                motor,
                chasis,
                marca,
                version,
                anio,
                valor,
            },
            bienesAsegurados: {
                id,
                descripcion,
                suma,
            },
        },
    } = props;
    const [openPhotoHelp, setOpenPhotoHelp] = useState(false);
    const {setFieldValue, values} = useFormikContext();

    const bienVacio = {
        [id.name]: '10',
        [descripcion.name]: '',
        [suma.name]: '',
    };

    return (
        <React.Fragment>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant='h6'>
                        Datos del vehículo
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <InputField
                        name={`motovehiculo.${patente.name}`}
                        label={patente.label}
                        fullWidth
                        textTransform={'uppercase'}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <InputField
                        name={`motovehiculo.${motor.name}`}
                        label={motor.label}
                        textTransform={'uppercase'}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <InputField
                        name={`motovehiculo.${chasis.name}`}
                        label={chasis.label}
                        textTransform={'uppercase'}
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <SlantedField value={values.motovehiculo.detalle_marca} label={marca.label}/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <SlantedField value={values.motovehiculo.anio} label={anio.label}/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <SlantedField value={values.motovehiculo.detalle_version} label={version.label}/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <SlantedField value={values.motovehiculo.valor.toLocaleString('es-ar', {
                        style: 'currency',
                        currency: 'ARS',
                        minimumFractionDigits: 0
                    })} label={valor.label}/>
                </Grid>
                <Grid item xs={12}>
                    <Divider variant="middle"/>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant='h6'>
                        Inspección previa
                        <ButtonBase onClick={() => setOpenPhotoHelp(true)}>
                            <PopOverCustom descripcion={'Ayuda'}/>
                        </ButtonBase>
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Dropzone
                        className={values.motovehiculo.inspeccionPrevia.archivos.length >= 6 && classes.disabled}
                        onDrop={(files) => {
                            let json = []
                            let len = values.motovehiculo.inspeccionPrevia.archivos.length
                            files.map(async function (file) {
                                if (len < 6) {
                                    json.push({
                                        "name": file.name,
                                        "content": "",
                                        "file": file
                                    })
                                }
                                len += 1
                            })
                            setFieldValue('motovehiculo.inspeccionPrevia.archivos', values.motovehiculo.inspeccionPrevia.archivos.concat(json));
                        }}
                        onReject={(files) => console.log('rejected files', files)}
                        maxSize={3 * 1024 ** 2}
                        maxFiles={6}
                        accept={[MIME_TYPES.png, MIME_TYPES.jpeg, MIME_TYPES.pdf]}
                        disabled={values.motovehiculo.inspeccionPrevia.archivos.length >= 6}
                        {...props}
                    >
                        <Group position="center" spacing="xl" style={{minHeight: 220, pointerEvents: 'none'}}>
                            <Dropzone.Accept>
                                <IconUpload
                                    size={50}
                                    stroke={1.5}
                                    // color={theme.colors[theme.primaryColor][theme.colorScheme === 'dark' ? 4 : 6]}
                                />
                            </Dropzone.Accept>
                            <Dropzone.Reject>
                                <IconX
                                    size={50}
                                    stroke={1.5}
                                    // color={theme.colors.red[theme.colorScheme === 'dark' ? 4 : 6]}
                                />
                            </Dropzone.Reject>
                            <Dropzone.Idle>
                                <IconPhoto size={50} stroke={1.5} />
                            </Dropzone.Idle>

                            <div>
                                <Text size="xl" inline align="center">
                                    Arrastre o haga clic para seleccionar los archivos
                                </Text>
                                <Text size="sm" color="dimmed" inline mt={7}>
                                    Puede adjuntar un máximo de 6 archivos (imágenes o pdf), cada archivo no debe superar los 5mb
                                </Text>
                            </div>
                        </Group>
                    </Dropzone>
                </Grid>
                <FieldArray name='motovehiculo.inspeccionPrevia.archivos'>{({remove}) => (
                    values.motovehiculo.inspeccionPrevia.archivos.map((file, index) => {
                        return (
                            <Grid item xs={6} sm={4}>
                                <Thumb product='MOTOVEHICULO' index={index} values={values} file={file.file}/>
                                <Button onClick={() => remove(index)}><ClearIcon/></Button>
                            </Grid>
                        )
                    })
                )}</FieldArray>

                <Grid item xs={12}>
                    <Typography variant='h6'>
                        Bienes asegurados (Adicionales)
                    </Typography>
                </Grid>
                <FieldArray name='bienesAsegurados'>{({remove}) => (
                    values.bienesAsegurados.map((e, index) => (
                        <Grid item container spacing={2} className={classes.listRow}>
                            <Grid item xs={4}>
                                <InputField
                                    name={`bienesAsegurados[${index}].${descripcion.name}`}
                                    label={descripcion.label}
                                    textTransform={'capitalize'}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <InputField
                                    name={`bienesAsegurados[${index}].${suma.name}`}
                                    label={suma.label}
                                    textTransform={'uppercase'}
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <Button onClick={() => remove(index)}><ClearIcon/></Button>
                            </Grid>
                        </Grid>
                    ))
                )}</FieldArray>
                <Grid item xs={12}>
                    <FieldArray name='bienesAsegurados'>{({push}) => (
                        <Button variant='outlined' className={classes.buttonForm2} onClick={() => push(bienVacio)}>Agregar
                            bien adicional</Button>
                    )}</FieldArray>
                </Grid>
            </Grid>
            <CarPhotosDialog open={openPhotoHelp} onClose={() => setOpenPhotoHelp(false)}/>
        </React.Fragment>
    );
}
